import {
  subDays,
  subMonths,
  subYears,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
} from 'date-fns'

export interface Range {
  startDate: Date
  endDate: Date
}

export const getRangeDates = (
  label: string,
  date: Date,
  startDate?: string | undefined
): Range => {
  switch (label) {
    case 'Last 30 Days':
      return {
        startDate: subDays(date, 30),
        endDate: date,
      }
    case 'This Month':
      return {
        startDate: startOfMonth(date),
        endDate: date,
      }
    case 'Last Month':
      return {
        startDate: startOfMonth(subMonths(date, 1)),
        endDate: endOfMonth(subMonths(date, 1)),
      }
    case 'Last 3 Months':
      return {
        startDate: startOfMonth(subMonths(date, 3)),
        endDate: endOfMonth(subMonths(date, 1)),
      }
    case 'Last 6 Months':
      return {
        startDate: startOfMonth(subMonths(date, 6)),
        endDate: endOfMonth(subMonths(date, 1)),
      }
    case 'This Year':
      return {
        startDate: startOfYear(date),
        endDate: date,
      }
    case 'Last Year':
      return {
        startDate: startOfYear(subYears(date, 1)),
        endDate: endOfYear(subYears(date, 1)),
      }
    case 'All Time':
      return {
        startDate: new Date(startDate ? startDate : '1970-01-01'),
        endDate: date,
      }
    default:
      return { startDate: date, endDate: date }
  }
}

export const stripTime = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate())
